import { Helpers } from './utility/helpers';

const siteThemes = ['light', 'dark', 'id26-light', 'id26-dark'] as const;

export type SiteTheme = (typeof siteThemes)[number];

export const getThemeClassnames = (theme: SiteTheme): string[] => {
    switch (theme) {
        case 'light':
            return ['theme-light'];
        case 'dark':
            return ['theme-dark'];
        case 'id26-light':
            return ['theme-id26-light'];
        case 'id26-dark':
            return ['theme-dark', 'theme-id26-dark'];
        default:
            return Helpers.exhaustiveCheck(theme);
    }
};

export const isSiteTheme = (value: unknown): value is SiteTheme => {
    return typeof value === 'string' && siteThemes.includes(value as SiteTheme);
};
